import { NUMBER, INTEGER, DATE, TIME, DATETIME } from '@/plugins/sdk/fields'
import isFinite from 'lodash/isFinite'
import isString from 'lodash/isString'
import isDate from 'lodash/isDate'

export default {
  label: 'Is less than',
  operator: 'is less than',
  fields: [ NUMBER, INTEGER, DATE, TIME, DATETIME ],
  isValidValue (value) {
    return isDate(value) || isFinite(value) || (isString(value) && value.length)
  }
}
